import React from 'react';
import styled from 'styled-components/macro';

import Headline3 from '../../../components/typography/Headline3';
import Headline1 from '../../../components/typography/Headline1';
import LabelLight from '../../../components/typography/LabelLight';

interface PageAttributeProps {
  attribute?: string | Date;
  label: string;
  isAttributeMain?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-top: 8px;
  min-width: 120px;
`;

const PageAttribute = ({ attribute, isAttributeMain, label }: PageAttributeProps) => {
  return (
    <Container>
      {
        isAttributeMain?
        <Headline1>{!!attribute ? attribute : '-'}</Headline1> :
        <Headline3>{!!attribute ? attribute : '-'}</Headline3> 
      }
      <LabelLight>{label}</LabelLight>
    </Container>
  );
};

export default PageAttribute;
